import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href", "fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  //xlink:href属性值的前缀
  prefix: {
    type: String,
    default: "#icon-"
  },
  //svg矢量图的名字
  name: String,
  //svg图标的颜色
  color: {
    type: String,
    default: ""
  },
  //svg宽度
  width: {
    type: String,
    default: "16px"
  },
  //svg高度
  height: {
    type: String,
    default: "16px"
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock("svg", {
      style: _normalizeStyle({ width: __props.width, height: __props.height })
    }, [
      _createElementVNode("use", {
        "xlink:href": __props.prefix + __props.name,
        fill: __props.color
      }, null, 8, _hoisted_1)
    ], 4))
  ]))
}
}

})